<template>
	<div>
		<triangle-image
			:title="title"
			:backgroundStyle="backgroundStyle">
		</triangle-image>

		<div class="content">
			<section class="paragraph">
				<h2>Ingredienti per rendere speciale il Natale 2020</h2>
				<p>	
				    1. Scoprire le nuove box Galbani, complete di tutti gli ingredienti necessari per realizzare fantastiche ricette Natalizie direttamente a casa tua.<br>
				    2. Scegliere la ricetta che preferisci dal catalogo: sei un tipo da Pandoro o Panettone?<br>
				    3. Ordina e paga con un click!<br><br>
					Ora non ti resta che aspettare... la tua box è già in viaggio verso di te!<br>
				</p>
			</section>
			<section class="mb-5 pb-5">
				<img src="https://api.quomi.it/oldimg/Box-Galbani-a-Casa-Tua.png">
			</section>
			<section slot="button">
				<div class="center">
					<router-link :to="{ name: 'flow-subscribed' }">
						<CTA
							content="Fai la tua spesa"
							class="ma-auto "
							isArrow
						/>
					</router-link>
				</div>
			</section>
		</div>
	</div>
</template>


<script type = "text/javascript" >

import TriangleImage from '@/components/TriangleImage'
import Usp from '@/components/Usp'
import { container } from '../../services/container'

export default {

	data () {
		return {
		}
	},

	components: {
		TriangleImage,
		Usp
	},

	computed: {

		user () {
			return this.$root.user
		},
		backgroundStyle () {
			return {
				backgroundImage: 'url(https://api.quomi.it/oldimg/galbani-1.jpg)',
				backgroundPosition: 'center 30%'
			}
		},
		title () {
			return 'Galbani A Casa Tua'
		},
		subtitle () {
			return 'Scopri il nuovo servizio che consegna ogni settimana un box ricco di ingredienti e ricette, comodamente a casa tua'
		},
	},
	mounted () {
		if (this.user && this.user.source === 'default') {
			return;
		}

		container.get('services.cookies').set('user_source_track', 'galbani');
		container.get('source').updateValue('galbani');
		
	}
}

</script>


<style scoped>

.content {
	max-width: 800px;
}

.paragraph p {
  margin-bottom: 45px;
}

.logos {
	margin: 20px 0;
}

</style>
